import React from 'react'
import styled from 'styled-components'

const Checkbox = ({ label, labelLeft, onAction, ...props }) => (
    <Label>
        {labelLeft && <span>{labelLeft}</span>}
        <Wrapper label={label} labelLeft={labelLeft}>
            <Input type="checkbox" {...props} onChange={onAction} />
            <Checker checked={props.checked} />
        </Wrapper>
        {label && <span>{label}</span>}
    </Label>
)

export default Checkbox

const Label = styled.label`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    -webkit-font-feature-settings: 'tnum';
    font-feature-settings: 'tnum';
    display: inline-block;
    line-height: unset;
    cursor: pointer;
`
const Wrapper = styled.span`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    -webkit-font-feature-settings: 'tnum';
    font-feature-settings: 'tnum';
    position: relative;
    top: -0.09em;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    vertical-align: middle;
    outline: none;
    cursor: pointer;
    margin-right: 15px;
    margin-left: 15px;
    ${({ labelLeft, label }) => (!labelLeft && !label ? ' width: 20px;' : '')}
`
const Checker = styled.span`
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 16px;
    height: 16px;
    background-color: ${({ checked }) => (checked ? '#1890ff' : '#fff')};
    border: 1px solid ${({ checked }) => (checked ? '#1890ff' : '#d9d9d9')};
    border-radius: 2px;
    border-collapse: separate;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    ${({ checked }) =>
        checked
            ? `
            &::after {
                position: absolute;
                top: 50%;
                left: 21%;
                display: table;
                width: 5.71428571px;
                height: 9.14285714px;
                border: 2px solid #fff;
                border-top: 0;
                border-left: 0;
                -webkit-transform: rotate(45deg) scale(0) translate(-50%, -50%);
                -ms-transform: rotate(45deg) scale(0) translate(-50%, -50%);
                transform: rotate(45deg) scale(0) translate(-50%, -50%);
                opacity: 0;
                -webkit-transition: all .1s cubic-bezier(.71, -0.46, .88, .6),opacity .1s;
                transition: all .1s cubic-bezier(.71, -0.46, .88, .6),opacity .1s;
                content: ' ';
                position: absolute;
    display: table;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
    -webkit-transform: rotate(45deg) scale(1) translate(-50%, -50%);
    -ms-transform: rotate(45deg) scale(1) translate(-50%, -50%);
    transform: rotate(45deg) scale(1) translate(-50%, -50%);
    opacity: 1;
    -webkit-transition: all .2s cubic-bezier(.12, .4, .29, 1.46) .1s;
    transition: all .2s cubic-bezier(.12, .4, .29, 1.46) .1s;
    content: ' ';
            }
            `
            : ''};
`
const Input = styled.input`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
`
